import React from 'react'
import svgs from '../svg'

const Icon = ({ name, className = '', ...props }) => {
  let c = name + ' ' + className
  if (svgs[name]) {
    return React.createElement(svgs[name], { ...props, className: c })
  }
  return <img src={ name } className={c} { ...props } alt={ name }/>
}

export default Icon
